"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.custom-branding.disabled': 'La función de marca personalizada no está disponible en su plan actual.',
};
